import { render, staticRenderFns } from "./OperatorOperatorNoticeHistory.vue?vue&type=template&id=487f001a&scoped=true"
import script from "./OperatorOperatorNoticeHistory.vue?vue&type=script&lang=js"
export * from "./OperatorOperatorNoticeHistory.vue?vue&type=script&lang=js"
import style0 from "./OperatorOperatorNoticeHistory.vue?vue&type=style&index=0&id=487f001a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487f001a",
  null
  
)

export default component.exports